import '@/styles/main.sass'
import 'unfonts.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from './router'
import { VueQueryPlugin } from '@tanstack/vue-query'
import sentry from './plugins/sentry'
import errors from './plugins/errors'

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.use(router).use(VueQueryPlugin).use(pinia).use(sentry).use(errors).mount('#app')
